export enum PlanTypes {
  GLOBAL_SOS = 'GLOBAL_SOS',
  LOW = 'LOW',
  BASIC = 'BASIC',
  STANDARD = 'STANDARD',
  UNLIMITED = 'UNLIMITED',
  NO_SERVICE_PLAN = 'NO_SERVICE_PLAN',
  EMSS = 'EMSS'
}
